import store from '../store';
import { PUSH_ALERT, POP_ALERT } from './types';
import { POPUP } from '../api/paidit-api';

export const pushAlert = payload => {
    if (payload.type === POPUP) {
        setTimeout(() => {
            store.dispatch(popAlert());
        }, payload.timeout || 2000);
    }

    return {
        type: PUSH_ALERT,
        payload
    };
};

export const popAlert = payload => {
    return {
        type: POP_ALERT,
        payload
    };
};